import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useInViewEffect} from '@aboutyou/ui-components';
import {useEffect} from 'react';

export const useReviewsABTest = () => {
  const {variant, activateAbTest} = useIsFeatureActive('ab_adp_bv3');

  const isABTestActive = Boolean(variant);

  const isControlGroup = variant === 'rvm-c';
  const isVariant1Active = variant === 'rvm-1';
  const isVariant2Active = variant === 'rvm-2';

  const {ref} = useInViewEffect<HTMLDivElement>(
    isInView => {
      isInView && activateAbTest();
    },
    {
      triggerOnce: true,
      skip: !isABTestActive,
    },
  );

  return {
    isABTestActive,
    reviewsSectionRef: ref,
    isControlGroup,
    shouldAlignRightReviewsButton: isVariant1Active,
    shouldShowUserReviews: isVariant1Active,
    shouldShowUserReviewsSlider: isVariant1Active,
    shouldShowPreviousReviewsImplementation: isVariant2Active,
    showQualityAndFitLabels: isVariant1Active,
  };
};

export const useProductDetailsReviewsABTest = (
  isReviewSectionAvailable: boolean,
) => {
  const {variant, activateAbTest} = useIsFeatureActive('desktop_adp_ratings');

  const shouldDisplayReviewsOnBuyboxAndProductDetails =
    variant === 'should-display-reviews-on-buybox-and-product-details';
  const shouldDisplayReviewsOnlyOnProductDetails =
    variant === 'should-display-reviews-only-on-product-details';
  const shouldActivateABTest = isReviewSectionAvailable && Boolean(variant);

  useEffect(() => {
    shouldActivateABTest && activateAbTest?.('ab_adp_bvd');
  }, []);

  return {
    showReviewsOnPriceAndBrand: shouldDisplayReviewsOnBuyboxAndProductDetails,
    showReviewsOnProductDetails:
      shouldDisplayReviewsOnBuyboxAndProductDetails ||
      shouldDisplayReviewsOnlyOnProductDetails,
  };
};
